// src/stores/settingsLocal.ts
export type DashboardSettings = {
  cards: {
    infoGlobal: boolean;
    placesLibres: boolean;
    infoRevenu: boolean;
    infoSolde : boolean;
    caMensuelChart: boolean;
    mapNationalites: boolean;
    nbBateauxChart: boolean;
    portStackedBars: boolean;
    doughnutFamilles: boolean;
    doughnutCategorieBat: boolean;
    doughnutTypeBat: boolean;
  };
};

export const DEFAULT_SETTINGS: DashboardSettings = {
  cards: {
    infoGlobal: true,
    placesLibres: true,
    infoRevenu: true,
    infoSolde: true,
    caMensuelChart: true,
    mapNationalites: true,
    nbBateauxChart: true,
    portStackedBars: true,
    doughnutFamilles: true,
    doughnutCategorieBat: true,
    doughnutTypeBat: true
  },
};

const LS_KEY = 'ui.dashboard.settings';

export function mergeWithDefaults(value?: Partial<DashboardSettings>): DashboardSettings {
  return {
    cards: { ...DEFAULT_SETTINGS.cards, ...(value?.cards ?? {}) },
  };
}

export function getSettingsFromLocal(): DashboardSettings {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return DEFAULT_SETTINGS;
    const parsed = JSON.parse(raw);
    return mergeWithDefaults(parsed);
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function setSettingsToLocal(s: DashboardSettings) {
  localStorage.setItem(LS_KEY, JSON.stringify(s));
  // évènement custom pour prévenir les autres composants du même onglet
  window.dispatchEvent(new CustomEvent('settings:updated'));
}
